// THE POPUP ALLOWS TESTERS TO START A CAMPAIGN WITHOUT USING SALESFORCE ADDING FISCAL CODES OF THE USERS
// THE COMPONENT CAN ALSO SET DIFFERENT TEMPLATE PARAMETERS TO RETRIEVE OLD ONES

import { useState, useEffect, useMemo } from 'react';

const TestingPopup = (props) => {

  const { api } = props;

  // THE DIFFERENT "PAGES" OF THE COMPONENT ARE INITIALIZED HERE
  const pages = useMemo(() => ['intro', 'addUsers', 'changeTemplate', 'campaignSuccess', 'campaignError'], []) ;

  // SET CURRENT ACTIVE PAGE
  const [page, setPage] = useState(pages[0]);

  // SET FISCAL CODES OF THE USERS TO START THE CAMPAIGN WITH
  const [users, setUsers] = useState(['']);

  // SET THE NEW IDPUSHTTL TO RETRIEVE OLD TEMPLATES
  const [idPushTTL, setIdPushTTL] = useState('');

  const [savedIds, setSavedIds] = useState([]);

  // SET THE RESULTS OF THE CAMPAIGN STARTED
  const [startCampaignResult, setStartCampaignResult] = useState({ failedUsers: [], pending: false, done: false });

  useEffect(() => {
    (async function () {
      setSavedIds(await api.retrieveIds());
    })();
  }, [api]);

  // "REDIRECT" TO RESULT PAGE BASED ON THE WHETHER THE CAMPAIGN WAS SUCCESSFUL OR NOT
  useEffect(() => {
    if (startCampaignResult.done) {
      startCampaignResult.failedUsers.length ? setPage(pages[4]) : setPage(pages[3]);
    }
   }, [startCampaignResult, pages])

  const backButton = () => (
    <button className="button button--secondary-dark" onClick={() => {
      setPage(pages[0]);
      setUsers(['']);
      setIdPushTTL('');
    }}
    >
      indietro
    </button>
  );

  const closeButton = () => (
    <button className="actions close" onClick={() => {
      setUsers(['']);
      setIdPushTTL('');
      props.close();
    }}
    >
      <i className="nexi-icon-close"></i>
    </button>
  );

  return (
    <div className="testing-popup">
      {page === 'intro' && (
        <div className="popup-wrapper">
          {closeButton()}
          <div className="popup-content">
            <div className="flow-tile-container">
              <button className="flow-tile" onClick={() => setPage(pages[1])}>INVIA CAMPAGNA</button>
              {STANDALONE && <button className="flow-tile" onClick={() => setPage(pages[2])}>RECUPERA TEMPLATE</button>}
            </div>
          </div>
        </div>
      )}
      {page === 'addUsers' && (
        <div className="popup-wrapper">
          {closeButton()}
          <div className="popup-content">
            <h1 className="popup-title">Inserisci i Codici Fiscali delle utenze per cui far partire la campagna</h1>
            <div className="fiscal-code-wrapper">
              {users.map((user, index) => (
                <div key={index} className="fiscal-code-container">
                  <input
                    className="input"
                    type="text"
                    value={user}
                    placeholder="codice fiscale"
                    onChange={(e) => setUsers(prev => prev.map((p, i) => i === index ? e.target.value : p))}
                  />
                  {users.length > 1 ?
                    <button className="fc-actions" onClick={() => setUsers(prev => prev.filter((_, i) => i !== index))}>
                      <i className="nexi-icon-close"></i>
                    </button>
                  : ''
                  }
                  {index === users.length - 1 ?
                    <button className="anchor anchor--dark" onClick={() => setUsers(prev => prev.concat(''))}>aggiungi</button>
                    : ''}
                </div>
              ))}
            </div>
          </div>
          <div className="popup-actions">
            {backButton()}
            <button disabled={startCampaignResult.pending || users.some(u => !u)} className="button button--primary-dark" onClick={async () => {
              setStartCampaignResult(prev => ({...prev, pending: true }))
              await Promise.all(users.map(async (u) => {
                // the api returns a boolean based on the result of the call
                const success = await props.api.startCampaign(u);
                if (!success) {
                  setStartCampaignResult(prev => ({ ...prev, failedUsers: prev.failedUsers.concat(u) }));
                }
              }));
              setStartCampaignResult(prev => ({ ...prev, done: true, pending: false }));
            }}>avvia campagna</button>
          </div>
        </div>
      )}
      {page === 'changeTemplate' && (
        <div className="popup-wrapper">
          {closeButton()}
          <div className="popup-content">
            <h1 className="popup-title">Seleziona l'id di un template per recuperarlo</h1>
            <div className="input-container">
              <label className="label" htmlFor="idPushTTL">ID template: &nbsp;</label>
              <select className="input" onChange={e => setIdPushTTL(e.target.value)}>
                <option value="" selected disabled hidden>Seleziona un ID</option>
                {savedIds.map(id => (
                  <option key={id} value={id}>{id}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="popup-actions">
          {backButton()}
          <button
            className="button button--primary-dark"
            onClick={() => {
              props.updateAppConfig(idPushTTL);
              props.close();
            }}
          >
            recupera template
          </button>
        </div>
        </div>
      )}
      {page === 'campaignError' && (
        <div className="popup-wrapper">
          {closeButton()}
          <div className="popup-content">
            <h1 className="popup-title">Errore! La campagna non è partita per gli utenti:</h1>
            <ul className="error-list">
              {startCampaignResult.failedUsers.map((u, i) => <li key={i}>{u}</li>)}
            </ul>
          </div>
          <div className="popup-actions">
            <button
              className="button button--primary-dark"
              onClick={() => {
                props.close();
              }}
            >
              chiudi
            </button>
          </div>
        </div>
      )}
      {page === 'campaignSuccess' && (
        <div className="popup-wrapper">
          {closeButton()}
          <div className="popup-content">
            <h1 className="popup-title">La campagna è stata avviata correttamente</h1>
          </div>
          <div className="popup-actions">
            <button
              className="button button--primary-dark"
              onClick={() => {
                props.close();
              }}
            >
              ok
            </button>
          </div>
        </div>
      )}
    </div>
  );

};

export default TestingPopup;